import { render, staticRenderFns } from "./PersonCenterType.vue?vue&type=template&id=8317b5da"
import script from "./PersonCenterType.vue?vue&type=script&lang=js"
export * from "./PersonCenterType.vue?vue&type=script&lang=js"
import style0 from "./PersonCenterType.vue?vue&type=style&index=0&id=8317b5da&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports